import { useCallback } from 'react';
import { NativeScrollEvent, NativeSyntheticEvent } from 'react-native';

import { UseCasinoCategoryGamesParams, useCasinoCategoryGames } from './use-casino-category-games';

const LOAD_MORE_OFFSET = 500;

/**
 * Infinite-scroll handler for the casino lobby content.
 *
 * Shared by the two scroll surfaces that can drive pagination: the mobile list's own ScrollView
 * in `CasinoCategoryList`, and the page-level ScrollView in `CasinoLobby.web.tsx` — on desktop
 * web the list renders bare inside that page scroll, so it has no scroll view of its own.
 *
 * Resolves the same datasource the list renders from; React Query shares the cache between the
 * two call sites
 */
export const useCasinoLobbyPagination = ({ isLobby, category }: UseCasinoCategoryGamesParams) => {
    const { data: categoryData, hasNextPage, loadMoreGames } = useCasinoCategoryGames({ isLobby, category });

    return useCallback(
        (event: NativeSyntheticEvent<NativeScrollEvent>) => {
            const { layoutMeasurement, contentOffset, contentSize } = event.nativeEvent;
            const isCloseToBottom = layoutMeasurement.height + contentOffset.y >= contentSize.height - LOAD_MORE_OFFSET;

            if (isCloseToBottom && hasNextPage && categoryData.length > 0) {
                loadMoreGames();
            }
        },
        [categoryData, hasNextPage, loadMoreGames]
    );
};
